import React from 'react';
import Forgotpassword from './components/Forgotpassword';
import Forgotpasswordmodal from './components/Forgotpasswordmodal';
import Modal from '../../components/Modal/Modal';
import modalReducer, { initialState } from '../../reducers/Modal.reducer';

const Forgotpasswordpage = () => {
  const [state, dispatch] = React.useReducer(modalReducer, initialState);

  const showModalSuccess = React.useCallback(() => {
    dispatch({ type: 'SHOW_MODAL_SUCCESS' });
  }, []);

  const showModalError = React.useCallback((errorMessage: string) => {
    dispatch({ type: 'SHOW_MODAL_ERROR', payload: errorMessage });
  }, []);

  const closeModal = React.useCallback(() => {
    dispatch({ type: 'CLOSE_MODAL' });
  }, []);

  return (
    <React.Fragment>
      <Forgotpassword showModalSuccess={showModalSuccess} showModalError={showModalError} />
      <Modal show={state.showModal} error={state.error} errorMessage={state.errorMessage} closeModal={closeModal}>
        <Forgotpasswordmodal />
      </Modal>
    </React.Fragment>
  );
};

export default Forgotpasswordpage;
